import _ from "lodash";
import React, { useMemo } from "react";
import { GetTheatreModeType } from "Utils/GetTheatreModeType";
import { PDFTRON_VIEWER_MODE_TYPES } from "Utils";
import { PdfTronViewerV3 } from "AppComponents/PdfTronViewer";

const PdfTronView = ({
  mediaAttachments,
  activeIndex,
  showPdfTronfeedback,
  onPdftronUpdateSuccessfullly,
  userInfo,
  studentDetails,
  onPdfTronSwitchToEditMode,
  invokeWorkbookCustomLoader,
  pdftronViewerMode = PDFTRON_VIEWER_MODE_TYPES["VIEWER"],
  fullScreenButtonStatus,
  toggleShowTheatreModeV2,
  showSaveButton,
  xfdfString,
  setPdftronInstance,
}) => {
  const mediaDataAttachments = _.get(mediaAttachments, "attachments");
  const currentAttachment =
    _.get(mediaDataAttachments, activeIndex) || mediaAttachments;

  const isPdfAttachment = useMemo(() => {
    const mediaDataAttachments = _.get(mediaAttachments, "attachments");
    const currentAttachment =
      _.get(mediaDataAttachments, activeIndex) || mediaAttachments;
    const theatreModeType = GetTheatreModeType({ media: currentAttachment });
    const isPdf = _.isEqual(theatreModeType, "PDFTRONVIEWER");

    return isPdf;
  }, [currentAttachment, activeIndex]);

  const useCustomLoader =
    isPdfAttachment && invokeWorkbookCustomLoader ? true : false;

  return (
    <PdfTronViewerV3
      hidePdfTronContainer={!isPdfAttachment}
      file={isPdfAttachment ? currentAttachment : null}
      shouldShowGiveFeedbackButton={showPdfTronfeedback}
      onPdfTronSwitchToEditMode={onPdfTronSwitchToEditMode}
      studentDetails={studentDetails}
      pdftronViewerMode={pdftronViewerMode}
      annotationUserInfo={userInfo}
      xfdfString={xfdfString}
      onUpdateSuccessfully={onPdftronUpdateSuccessfullly}
      useCustomLoader={useCustomLoader}
      showHeaderOptionsForViewMode={false}
      fullScreenButtonStatus={fullScreenButtonStatus}
      toggleShowTheatreModeV2={toggleShowTheatreModeV2}
      showSaveButton={showSaveButton}
      setPdftronInstance={setPdftronInstance}
    />
  );
};

export default PdfTronView;
